import { render, staticRenderFns } from "./OfflineTimeoutReminder.vue?vue&type=template&id=2ef5fa3c&scoped=true&"
import script from "./OfflineTimeoutReminder.vue?vue&type=script&lang=js&"
export * from "./OfflineTimeoutReminder.vue?vue&type=script&lang=js&"
import style0 from "./OfflineTimeoutReminder.vue?vue&type=style&index=0&id=2ef5fa3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5fa3c",
  null
  
)

export default component.exports